(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAnnbar(scope) {
      var track = scope.querySelector('[data-annbar-rotate]');
      if (!track || track.__rotTimer) return;
      var items = track.querySelectorAll('.pj-annbar__item');
      if (items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      items.forEach(function (it, n) { it.classList.toggle('is-on', n === 0); });
      track.__rotTimer = setInterval(function () {
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, 3400);
    }
    document.querySelectorAll('.pj-annbar').forEach(initAnnbar);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.pj-annbar')) initAnnbar(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var track = e.target.querySelector('[data-annbar-rotate]');
      if (track && track.__rotTimer) clearInterval(track.__rotTimer);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
